<template>
  <div class="review">
    <div class="banner-top">
      <div class="banner-box"></div>
      <div class="banner-desc">多维度、多周期的及时深度复盘</div>
    </div>
    <div class="review-box">
      <el-row :gutter="20">
        <el-col :span="8" v-for="(item, i) in menuList" :key="i">
          <el-tooltip class="item" effect="light" :content="item.desc" placement="bottom" popper-class="third-tooltip">
          <div class="grid-content bg-purple cursorPointer" @click="token && selectMenu(i)">
            <div :class="currentIndex === i ? 'active' : ''"><img class="small-img" :src="currentIndex === i ? item.imgUrl : item.imgUrls" alt="">{{item.txt}}</div>
          </div>
          </el-tooltip>
        </el-col>
      </el-row>

      <div class="list" v-show="currentIndex === ''">
        <div class="list-box" v-for="(item,i) in itemList" :key="i">
          <div class="img-box">
            <img class="thumb-img" :src="item.img" alt="">
          </div>
          <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=review'">
            <div class="article_title">
              <div class="title">{{ item.title }}</div>
              <div class="list-content">{{ item.desc }}</div>
              <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
            </div>
          </a>
        </div>
        <div class="more">
          <div class="cursorPointer">
            <div @click="getMore">点击加载更多...</div>
          </div>
        </div>
      </div>

      <div class="list" v-show="currentIndex === 0">
        <div class="list-box" v-for="(item,i) in itemSpGcList" :key="i">
          <div class="img-box">
            <img class="thumb-img" :src="item.img" alt="">
          </div>
          <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=review'">
            <div class="article_title">
              <div class="title">{{ item.title }}</div>
              <div class="list-content">{{ item.desc }}</div>
              <div class="list-bottom">{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
            </div>
          </a>
        </div>
        <div class="more">
          <div class="cursorPointer">
            <div @click="getSpGcMore">点击加载更多...</div>
          </div>
        </div>
      </div>

      <div class="list" v-show="currentIndex === 1">
        <div class="list-box" v-for="(item,i) in itemSjJpList" :key="i">
          <div class="img-box">
            <img class="thumb-img" :src="item.img" alt="">
          </div>
          <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=review'">
            <div class="article_title">
              <div class="title">{{ item.title }}</div>
              <div class="list-content">{{ item.desc }}</div>
              <div class="list-bottom">{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
            </div>
          </a>
        </div>
        <div class="more">
          <div class="cursorPointer">
            <div @click="getSjJpMore">点击加载更多...</div>
          </div>
        </div>
      </div>

      <div class="list" v-show="currentIndex === 2">
        <div class="list-box" v-for="(item,i) in itemMzFpList" :key="i">
          <div class="img-box">
            <img class="thumb-img" :src="item.img" alt="">
          </div>
          <a class="list-title" :href="'/#/detail?id='+item.id+'&mid='+item.modelprp_id+'&catname='+item.name+'&cate=review'">
            <div class="article_title">
              <div class="title">{{ item.title }}</div>
              <div class="list-content">{{ item.desc }}</div>
              <div class="list-bottom">{{ item.name }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ item.hour }}</div>
            </div>
          </a>
        </div>
        <div class="more">
          <div class="cursorPointer">
            <div @click="getMzFpMore">点击加载更多...</div>
          </div>
        </div>
      </div>
    </div>

    <div class="back-top" @click="backTop" v-show="btnFlag">
      <img src="../assets/images/return_top.png" alt="" srcset="">
    </div>
  </div>

</template>

<script>
import { FpAll, SpGc, SjJp, MzFp } from "@/api/news";

export default {
  name: "Review",
  data() {
    return {
      itemList: [],
      itemSpGcList: [],
      itemSjJpList: [],
      itemMzFpList: [],
      scroll:0,//第一步：定义初始滚动高度
      token: window.localStorage.getItem('token'),
      page: 1,
      spPage:1,
      jpPage:1,
      fpPage:1,
      btnFlag: false,
      currentIndex:'',
      menuList:[
        {
          imgUrl: require('../assets/images/icon_收盘观潮2.png'),
          imgUrls: require('../assets/images/icon_收盘观潮1.png'),
          txt: '收盘观潮',
          desc: '全面、深度、及时的每日复盘分析（更新频率：交易日16:00前）'
        },
        {
          imgUrl: require('../assets/images/icon_数据解盘2.png'),
          imgUrls: require('../assets/images/icon_数据解盘1.png'),
          txt: '数据解盘',
          desc: '资金数据结合基本面、技术面、市场风格等研判个股（更新频率：交易日盘前）'
        },
        {
          imgUrl: require('../assets/images/icon_每周复盘2.png'),
          imgUrls: require('../assets/images/icon_每周复盘1.png'),
          txt: '每周复盘',
          desc: '对各细分领域进行的深度复盘（更新频率：每周日18:00前）'
        },
      ]
    }
  },
  created() {
    this.$emit('header', true);
    this.$emit('footer', true);
    this.getAllList()
    this.getSpGcList()
    this.getSjJpList()
    this.getMzFpList()
  },
  mounted() {
    this.toJump()
    window.addEventListener('scroll', this.scrollToTop)
    window.addEventListener('scroll', this.handleScroll);
  },
  activated(){
    if(this.scroll > 0){
      window.scrollTo(0, this.scroll);
      window.addEventListener('scroll', this.handleScroll);
    }
  },
  deactivated(){
    window.removeEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    handleScroll () {
      this.scroll  = $(window).height()+ $(document).scrollTop()
    },
    toJump(){
      if(this.$route.query.activeName!=null){
        this.activeName = this.$route.query.activeName;
        this.currentTab = this.$route.query.currentTab;
        const current = this.currentTab;
        // console.log(current);
        if(current ==='first'){
          this.currentIndex = 0
        }else if(current ==='second'){
          this.currentIndex = 1
        }else if(current ==='third'){
          this.currentIndex = 2
        }
      }
    },
    selectMenu(index) {
      this.currentIndex = index
    },
    getAllList() {
      FpAll({id: '1fwn9769jkq', page: this.page}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemList = this.itemList.concat(response.data.data)
        }
      });
    },
    getSpGcList() {
      SpGc({id: '1gp04oxi3am', page: this.spPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemSpGcList = this.itemSpGcList.concat(response.data.data)
        }
      });
    },
    getSjJpList() {
      SjJp({id: '1ov7pffoq6n', page: this.jpPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemSjJpList = this.itemSjJpList.concat(response.data.data)
        }
      });
    },
    getMzFpList() {
      MzFp({id: '1h6q6dip12s', page: this.fpPage}).then((response) => {
        if (response.code === 2000 || response.code === 505 || response.code === 403) {
          this.itemMzFpList = this.itemMzFpList.concat(response.data.data)
        }
      });
    },
    getMore() {
      this.page++;
      this.getAllList()
    },
    getSpGcMore() {
      this.spPage++;
      this.getSpGcList()
    },
    getSjJpMore() {
      this.jpPage++;
      this.getSjJpList()
    },
    getMzFpMore() {
      this.fpPage++;
      this.getMzFpList()
    },
    backTop() {
      const that = this
      let timer = setInterval(() => {
        let isPeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + isPeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16);
    },
    scrollToTop() {
      const that = this
      that.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
  },
}
</script>

<style scoped>
.review {
  background-color: #F5F7FA;
}
.review-box {
  width: 1200px;
  margin: -30px auto 0;
}
.active{
  color: #ffe400;
}
.banner-top {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  line-height: 70px;
  background: url("../assets/images/banner_top.png") no-repeat center / cover;
}
.banner-box {
  width: 1200px;
  margin: 0 auto;
}
.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.banner-desc {
  text-align: center;
  font-size: 14px;
  color: #FFFFFF;
}

.bg-purple {
  background: #d3dce6;
}

.grid-content {
  height: 60px;
  color: white;
  background-image: linear-gradient(#0c255c, #040f27);
  line-height: 60px;
  font-size: 16px;
  padding-left: 50px;
}

.cursorPointer {
  cursor: pointer;
}

.small-img {
  height: 30px;
  padding-right: 20px;
  vertical-align: middle;
}

.list {
  margin: 10px 0;
}

.list-box {
  display: flex;
  background-color: #ffffff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  height: 120px;
  padding: 10px 20px;
}


.img-box {
  margin-right: 40px;
}

.thumb-img {
  width: 240px;
  height: 120px;
  flex: 0 0 240px;
}

.list-title {
  position: relative;
}

.title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #313131;
}

.list-content {
  font-size: 14px;
  line-height: 28px;
  color: #898989;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.list-bottom {
  font-size: 14px;
  bottom: 0;
  min-width: 860px;
  color: #898989;
  position: absolute;
  pointer-events: none;
}

.more {
  width: 100%;
  height: 40px;
  line-height: 40px;
  margin: 10px 0;
  font-size: 12px;
  color: #a0a8b0;
  text-align: center;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.back-top {
  position: fixed;
  right: 40px;
  bottom: 40px;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.1);
}

</style>



// WEBPACK FOOTER //
// src/components/Review.vue